// extracted by mini-css-extract-plugin
export default {"number":"numberInput_number__h4se1"};